import React from "react";

const Title = ({ appendClass, value }) => {
  return <h1 className={`text-2xl mb-6 ${appendClass}`}>{value}</h1>;
};

export default Title;
